import { render, staticRenderFns } from "./AuthSubTitle.vue?vue&type=template&id=24118387"
import script from "./AuthSubTitle.vue?vue&type=script&lang=ts"
export * from "./AuthSubTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24118387')) {
      api.createRecord('24118387', component.options)
    } else {
      api.reload('24118387', component.options)
    }
    module.hot.accept("./AuthSubTitle.vue?vue&type=template&id=24118387", function () {
      api.rerender('24118387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/AuthSubTitle.vue"
export default component.exports